"use client";

import { useConsent } from "./consent-store";

/**
 * Floating shield button — lets a visitor reopen the cookie-preferences modal
 * at any time after they have made a decision (LGPD: consent must be as easy
 * to withdraw as to give).
 */
export function CookieConsentIndicator({
  bannerEnabled,
  onOpen,
}: {
  bannerEnabled: boolean;
  onOpen: () => void;
}) {
  const { hasDecided, hydrated } = useConsent();
  if (!hydrated || !bannerEnabled || !hasDecided) return null;

  return (
    <button
      type="button"
      className="lgpd-indicator"
      onClick={onOpen}
      aria-label="Preferências de cookies"
      title="Preferências de cookies"
    >
      <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden focusable="false">
        <path
          fill="currentColor"
          d="M12 2 4 5v6c0 5 3.4 9.7 8 11 4.6-1.3 8-6 8-11V5l-8-3Zm0 2.2 6 2.25V11c0 4-2.6 7.9-6 9-3.4-1.1-6-5-6-9V6.45l6-2.25Z"
        />
        <path fill="currentColor" d="m10.6 13.2-1.9-1.9-1.3 1.3 3.2 3.2 5.4-5.4-1.3-1.3-4.1 4.1Z" />
      </svg>
    </button>
  );
}
